import { Flex, useColorMode } from '@chakra-ui/react'
import React, { useEffect } from 'react'

import './Login.styles.css'

const StaticBackground = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      height="100vh"
      width="100%"
      position="absolute"
      display="flex"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
    >
      {children}
    </Flex>
  )
}

export const LoginBackground = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [selectedModeIndex, setSelectedModeIndex] = React.useState(0)
  useEffect(() => {
    setSelectedModeIndex(Math.floor(Math.random() * gradients.length))
  }, [])
  const colorMode = useColorMode()
  const gradients = [
    'login-gradient-2tone-bottomRight',
    'login-gradient-2tone-bottomLeft',
    'login-gradient-2tone-top',
  ]

  const selectedMode = gradients[selectedModeIndex]
  const gradientClass = `${selectedMode}-${colorMode.colorMode}`
  return (
    <StaticBackground>
      <div className={`login-gradient-container ${gradientClass}`} />
      {children}
    </StaticBackground>
  )
}
